import { render, staticRenderFns } from "./Reset_password.vue?vue&type=template&id=4de45a28&scoped=true"
import script from "./Reset_password.vue?vue&type=script&lang=js"
export * from "./Reset_password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de45a28",
  null
  
)

export default component.exports